<template>
  <highcharts :options="chartOptions" />
</template>

<script>
import Highcharts from 'highcharts';
import { Chart } from 'highcharts-vue';
import networkgraph from 'highcharts/modules/networkgraph';
import exportingInit from 'highcharts/modules/exporting';

networkgraph(Highcharts);
exportingInit(Highcharts);

export default {
  name: 'NetworkChart',

  components: {
    highcharts: Chart,
  },

  props: {
    titulo: {
      type: String,
      default: 'Organograma da Unidade',
      required: false,
    },
    fonte: {
      type: String,
      required: false,
      default: 'Fonte: Sistema Gestão Por Competência (UFC)',
    },
    dados: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    nos: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },

  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'networkgraph',
          style: {
            fontFamily: 'Roboto;Arial;sans-serif',
          },
          height: 400,
          events: {
            load() {
              const chart = this;
              chart.updatingFlag = false;
              chart.updatedFlag = false;
            },
            render() {
              const chart = this;
              if (chart.fullscreen.isOpen && !chart.updatingFlag && !chart.updatedFlag) {
                chart.updatingFlag = true;
                const oldSeries = chart.options.series;
                oldSeries[0].nodes = oldSeries[0].nodes.map((n) => ({
                  ...n,
                  marker: { radius: { 22: 55, 30: 75 }[n.marker.radius] },
                }));

                chart.update({
                  plotOptions: {
                    series: {
                      dataLabels: {
                        style: {
                          fontSize: '20px',
                        },
                      },
                    },
                  },
                  tooltip: {
                    style: {
                      fontSize: '20px',
                    },
                  },
                  series: oldSeries,
                  chart: {
                    height: window.screen.height,
                  },
                });
                chart.reflow();
                chart.updatingFlag = false;
                chart.updatedFlag = true;
              }

              if (!chart.fullscreen.isOpen && !chart.updatingFlag && chart.updatedFlag) {
                chart.updatingFlag = true;
                const oldSeries = chart.options.series;
                oldSeries[0].nodes = oldSeries[0].nodes.map((n) => ({
                  ...n,
                  marker: { radius: { 55: 22, 75: 30 }[n.marker.radius] },
                }));

                chart.update({
                  plotOptions: {
                    series: {
                      dataLabels: {
                        style: {
                          fontSize: '12px',
                        },
                      },
                    },
                  },
                  tooltip: {
                    style: {
                      fontSize: '12px',
                    },
                  },
                  series: oldSeries,
                  chart: {
                    height: 400,
                  },
                });
                chart.updatingFlag = false;
                chart.updatedFlag = false;
              }
            },
          },
        },
        exporting: {
          menuItemDefinitions: {
            viewFullscreen: {
              textKey: 'viewFullscreen',
              onclick() {
                this.update({
                  tooltip: {
                    outside: this.fullscreen.isOpen,
                  },
                });
                this.fullscreen.toggle();
              },
            },
          },
        },
        credits: {
          enabled: true,
        },
        title: {
          text: this.titulo === '' ? '' : this.titulo,
        },
        subtitle: {
          text: this.fonte,
        },
        plotOptions: {
          networkgraph: {
            keys: ['from', 'to', 'info'],
          },
        },
        series: [
          {
            id: 'lang-tree',
            data: this.dados,
            nodes: this.nos,
            dataLabels: {
              enabled: true,
              linkFormat: '',
            },
          },
        ],
        tooltip: {
          outside: true,
          allowHTML: true,
          distance: 50,
          formatter() {
            return this.point.info;
          },
        },
        lang: {
          contextButtonTitle: 'Opções do Gráfico',
          viewFullscreen: 'Ver em Tela Cheia',
          printChart: 'Imprimir Gráfico',
          downloadJPEG: 'Baixar como Imagem JPEG',
          downloadPNG: 'Baixar como Imagem PNG',
          downloadPDF: 'Baixar como Documento PDF',
          downloadSVG: 'Baixar como Vetor de Imagem SVG',
          exitFullscreen: 'Sair do modo Tela Cheia',
          loading: 'Carregando...',
          noData: 'Não há dados disponíveis',
        },
      };
    },
  },
};
</script>
